import type React from "react";
import { useState } from "react";

import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { BaseButton } from "../BaseButton/BaseButton";
import { MUISelect } from "../MUI/MUISelect";

type Option = {
  label: string;
  value: number | string;
};

interface BulkActionsFormProps {
  options: number[] | string[] | Option[];
  onSubmit: (selectedValue: number | string) => void;
  disabled?: boolean;
}

export const BulkActionsForm: React.FC<BulkActionsFormProps> = ({ options, onSubmit, disabled = false }) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState<number | string>("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedValue !== "") {
      onSubmit(selectedValue);
    }
  };

  return (
    <StyledForm onSubmit={handleSubmit}>
      <MUISelect
        label={t("form.bulk_actions")}
        options={options}
        value={selectedValue}
        onChange={e => setSelectedValue(e.target.value as number | string)}
        fullWidth
        disabled={disabled}
        size="small"
        sx={{ minWidth: 180 }}
      />
      <BaseButton
        type="submit"
        text={t("buttons.apply")}
        variant="action"
        disabled={disabled || selectedValue === ""}
      />
    </StyledForm>
  );
};

const StyledForm = styled.form`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;
